import { useEffect, useRef } from 'react';

/*
 * This is a hook which can be imported and used in your component.
 * It is best used with a prop in the form of:
 *    const prevPropName = usePrevious(propName);
 * Where it will be able to be used to gain access to the previous
 * rendered value of that variable.  i.e. Previous prop's value
 */

export default function usePrevious(value, initialValue) {
  if (initialValue === void 0) {
    initialValue = null;
  }
  const ref = useRef(initialValue);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}